// extracted by mini-css-extract-plugin
export default {"TypeSelector":"TypeSelector_TypeSelector__ulp89","Option":"TypeSelector_Option__lIgVO","SelectedOption":"TypeSelector_SelectedOption__-3jDZ","Icon":"TypeSelector_Icon__KEbAQ"};